import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const fileContentServiceMutations : UpdatesConfig['Mutation'] = {
  fileContentServiceCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('fileContentServices', cache);
  },
  fileContentServiceAsyncCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('fileContentServices', cache);
  },
};

export default fileContentServiceMutations;
